module.exports = __webpack_public_path__ + "static/media/powered_voltaware.24da1519.svg";